import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { trackPageview } from "@/lib/track";

export function useSettings() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/settings/public").then((r) => alive && setSettings(r.data)).catch(() => {});
    return () => { alive = false; };
  }, []);
  return settings;
}

export function useSEO({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
      }
      m.content = description;
    }
  }, [title, description]);
}

/**
 * Logs a pageview on every route change.
 * Skips /admin/* paths to avoid polluting public stats with admin traffic.
 */
export function usePageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname + location.search;
    if (path.startsWith("/admin")) return;
    trackPageview(path);
  }, [location.pathname, location.search]);
}

/**
 * Fetches a content block managed by the admin CMS.
 * @param {string} key e.g. "home.hero"
 * @param {object} fallback default content if the block does not exist yet
 */
export function usePageContent(key, fallback = {}) {
  const [content, setContent] = useState(fallback);
  useEffect(() => {
    let alive = true;
    api.get(`/page-content/${key}`)
      .then((r) => {
        if (!alive) return;
        const c = r.data?.content;
        if (c && Object.keys(c).length) setContent({ ...fallback, ...c });
      })
      .catch(() => {});
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return content;
}
